
import { mapState, mapActions, mapMutations } from 'vuex'

import DefaultForm from '@pleinair/bigcolony-vue/components/_globals/forms/DefaultForm.vue'
import AccountReferral from '@/components/account/AccountReferral.vue'

export default {
  name: 'AccountInfoSection',
  components: {
    AccountReferral,
    DefaultForm,
  },
  data() {
    return {
      showDeleteAccount: false,
    }
  },
  computed: {
    ...mapState([ 'token', 'user', 'activeAccountSection' ]),
    isMobile() {
      return this.$mq == 'sm' || this.$mq == 'md' ? true : false
    },
    infoFields() {
      return [
        {
          name: 'email',
          label: 'Email Address',
          placeholder: 'Email Address',
          value: this.user?.email ? this.user.email : null,
          type: 'email',
          required: true,
          disabled: true,
          valid: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          errors: {
            invalid: 'Please enter a valid email address.'
          }
        },
        {
          name: 'first_name',
          label: 'First Name',
          placeholder: 'First Name',
          value: this.user?.first_name ? this.user.first_name : null,
          autocomplete: 'firstName',
          type: 'text',
          required: true,
          disabled: true,
          valid: /^[A-Za-z\s]*$/,
          errors: {
            invalid: 'Names may only contain letters'
          }
        },
        {
          name: 'last_name',
          label: 'Last Name',
          placeholder: 'Last Name',
          value: this.user?.last_name ? this.user.last_name : null,
          autocomplete: 'lastName',
          type: 'text',
          required: true,
          disabled: true,
          valid: /^[A-Za-z\s]*$/,
          errors: {
            invalid: 'Names may only contain letters'
          }
        },
        {
          name: 'phone',
          label: 'Phone Number',
          placeholder: 'Phone Number',
          value: this.user?.phone ? this.user.phone : null,
          autocomplete: 'phoneNumber',
          type: 'text',
          mask: '###-###-####',
          required: false,
          disabled: true, // phone number cannot be updated
          valid: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
          errors: {
            invalid: 'Please enter a valid US phone number'
          }
        },
        {
          name: 'dob',
          label: 'Date of Birth',
          type: 'date-select',
          default: this.user?.dob ? this.user.dob : null,
          value: this.user?.dob ? this.user.dob : null,
          valid: /^\d{4}-\d{2}-\d{2}$/,
          required: false,
          disabled: true, // Punchh does not allow to update the dob
          errors: {
            invalid: 'Please enter a valid Date of Birth'
          }
        },
      ]
    },
  },
  async beforeMount() {
    if(!this.token) {
      this.$router.push('/account/signin')
    }
  },
  methods: {
    ...mapActions({
      updateUser: 'members/updateMember'
    }),
    ...mapMutations([ 'setLoading', 'setErrors' ]),
    
    goToDeleteAccount() {
      window.open('https://www.spendgo.com/help/delete-my-account', '_self')
    }
  }
}
